import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startChangeFlartStatus: 'idle',
    startChangeFlartError: undefined as any,
    loadUserParamsChangeFlartStatus: 'idle',
    loadUserParamsChangeFlartError: undefined as any,

    changeFlartList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startChangeFlart = createAsyncThunk('changeFlartSlice/startChangeFlart', async ({ changeFlart }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartChangeFlart/`,
        prepareData(changeFlart),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startChangeFlartStatus } = getState().changeFlartSlice
        return startChangeFlartStatus !== 'pending'
    }
})

export const loadUserParamsChangeFlart = createAsyncThunk('changeFlartSlice/loadUserParamsChangeFlart', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsChangeFlart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsChangeFlartStatus } = getState().changeFlartSlice
        return loadUserParamsChangeFlartStatus !== 'pending'
    }
})

const ChangeFlartSlice = createSlice({
    name: 'changeFlartSlice',
    initialState,
    reducers: {
        resetstartChangeFlart: (state) => {
            state.job = undefined
            state.startChangeFlartError = undefined
        },
        resetstartChangeFlartError: (state) => {
            state.startChangeFlartError = undefined
        },
        resetloadUserParamsChangeFlart: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsChangeFlartError = undefined
        },
        resetloadUserParamsChangeFlartError: (state) => {
            state.loadUserParamsChangeFlartError = undefined
        },
        removeFromChangeFlartListById: (state, action) => {
            state.changeFlartList = state.changeFlartList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromChangeFlartListByIds: (state, action) => {
            state.changeFlartList = state.changeFlartList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.changeFlartList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startChangeFlartStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.changeFlartList = []
            state.startChangeFlartStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startChangeFlart.pending, (state) => {
            state.startChangeFlartStatus = 'pending'
            state.startChangeFlartError = undefined
        })
        builder.addCase(startChangeFlart.fulfilled, (state, action) => {
            state.startChangeFlartStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startChangeFlart.rejected, (state, action) => {
            state.startChangeFlartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startChangeFlartError = action.error.message
            } else {
                state.startChangeFlartError = action.payload
            }
        })

        builder.addCase(loadUserParamsChangeFlart.pending, (state) => {
            state.loadUserParamsChangeFlartStatus = 'pending'
            state.loadUserParamsChangeFlartError = undefined
        })
        builder.addCase(loadUserParamsChangeFlart.fulfilled, (state, action) => {
            state.loadUserParamsChangeFlartStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsChangeFlart.rejected, (state, action) => {
            state.loadUserParamsChangeFlartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsChangeFlartError = action.error.message
            } else {
                state.loadUserParamsChangeFlartError = action.payload
            }
        })

    }
})

export const {
    resetstartChangeFlart,
    resetstartChangeFlartError,
    resetloadUserParamsChangeFlart,
    resetloadUserParamsChangeFlartError,
    removeFromChangeFlartListById,
    removeFromChangeFlartListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ChangeFlartSlice.actions
export default ChangeFlartSlice.reducer
